<template>
  <div class="wh-100">
    <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="true" :rowselect="true">
    </nk-table>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable";
import computer from "@/utils/computer.js";
export default {
  components: { NkTable },
  data () {
    return {
      columns: [],
      tableData: []
    }
  },
  methods: {
    init (config, table) {
      console.log('表格')
      console.log(table)
      let columns = [
        {
          label: "序号",
          show: true,
          width: "100",
          type: "index",
          align: "center",
        },
        {
          label: "测量点名称",
          show: true,
          prop: 'name',
          width: "150",
          align: "center",
        }]
      let tableData = []
      for (let i = 0; i < config.columns.length; i++) {
        const element = config.columns[i];
        columns.push({
          prop: "column" + "_" + i,
          label: element.name,
          align: "center",
          show: true,
          width: "100",
        })
      }

      this.columns = columns
      table = computer.trtdToExp(config.columns, table);

      for (let i = 1; i < table.length; i++) {
        const element = table[i];
        let tr = {
          name: element[0]
        }
        for (let j = 0; j < config.columns.length; j++) {
          const colName = "column" + "_" + j
          tr[colName] = element[j + 1]
        }
        tableData.push(tr)
      }
      this.tableData = tableData
    }
  }
}
</script>

<style lang="scss" scoped>
.wh-100 {
  width: 100%;
  height: 100%;
}
</style>